export default [
  "one keyword",
  "two keyword",
  "another keyword",
  "more keyword",
  "even more keyword",
  "keyword",
  "locks",
  "locksmith",
  "keychain",
  "keybase"
]
